// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';
import MediaQuery from 'react-responsive';

import {
  BasketItem,
  InputWithButton,
  BasketTotal,
  Loader,
  DeleteModal,
} from '../../../../components';
import VoucherGroups from '../VoucherGroups/VoucherGroups';
import styles from './styles';
import Checkout from '../Checkout/Checkout';
import IssueVoucher from '../IssueVoucher/IssueVoucher';

class BasketPaperInfo extends Component {
  state = {
    modal: false,
  };

  onDelete = (item) => {
    this.setState({ modal: true });
    this.props.setDeleteItem(item);
  }

  onAgree = () => {
    this.setState({ modal: false });
    const token = localStorage.getItem('token');
    const customerId = localStorage.getItem('loggedID');
    this.props.removeItem(this.props.deleteItem, token, customerId);
    this.props.setDeleteItem(null);
  }

  onClose = () => {
    this.setState({ modal: false });
    this.props.setDeleteItem(null);
  }

  onPress = () => {
    if (!this.props.disableGetPriceButton) {
      this.props.onSearch(this.props.search.EAN);
    }
  }

  render() {
    const {
      classes, error, total, checkoutForTradeCustomer, basketNotifyError, disableGetPriceButton
    } = this.props;

    const isBookshop = parseInt(localStorage.getItem('isBookshop'), 10);
    const { bookshopBasket } = this.props;

    // Books already covered by a voucher are shown grouped under it, so only
    // the rest belong in the flat list below.
    const vouchered = isBookshop && bookshopBasket ? bookshopBasket.VoucherGroups || [] : [];
    const items = isBookshop
      ? this.props.basket.filter(book => !book.VoucherId)
      : this.props.basket;

    // What the shop sees at the top is the unvouchered remainder, not the
    // whole basket - that is the figure that decides whether a voucher can be
    // issued for the customer at the till. The basket's full value is what
    // checkout charges, and it is shown there. The app does the same.
    const headlineTotal = isBookshop
      ? {
        items: items.length,
        price: parseFloat((bookshopBasket && bookshopBasket.UnvoucheredValue) != null
          ? bookshopBasket.UnvoucheredValue
          : total.redeemValue) || 0,
      }
      : { items: total.items, price: total.price };

    let needItem = 10;
    let needMoney = 10;
    needMoney = 10 - total.price;
    needMoney = parseFloat(Math.round(needMoney * 100) / 100).toFixed(2);
    needItem = 10 - total.items;
    const isAll = needMoney <= 0 || needItem <= 0;

    const alert = `Just add ${needItem} more item(s) or £${needMoney} worth of 
    stuff and you can send us your shipment`;
    const inputProps = {
      value: this.props.search.EAN,
      onChangeInput: this.props.onChangeInput,
      onPress: () => this.onPress(),
      name: 'EAN',
      placeholder: 'Enter barcode, ISBN or EAN',
      error,
      basketNotifyError,
    };
    return (
      <div className={classes.mainContainer}>
        <DeleteModal
          modal={this.state.modal}
          onAgree={this.onAgree}
          closeModal={this.onClose}
          deleteItem={this.state.deleteItem}
          question={'Are you sure you want to delete it?'}
        />
        <div className={classes.topContainer}>
          <div className={classes.topLeftContainer}>
            <span className={classes.titleText}>
              Start selling here and get the
              <span className={classes.blueText}> highest instant cash offer </span>
              for your items now!
            </span>
            <MediaQuery minWidth={500}>
              {matches => (matches
                ? <InputWithButton {...inputProps} bottomHelper disabled={disableGetPriceButton} />
                : <InputWithButton {...inputProps} disabled={disableGetPriceButton} />)}
            </MediaQuery>
          </div>
          <BasketTotal
            marginVertical
            price={headlineTotal.price}
            items={headlineTotal.items}
            isAll={isAll}
            haveClearBasket
          />
        </div>
        <div className={classes.buttonsCOntainer}>
          { (isBookshop && total.redeemValue !== 0) ? <IssueVoucher /> : null}
          {isAll
            ? <Checkout checkoutForTradeCustomer={checkoutForTradeCustomer} total={total} />
            : (
              <div className={classes.alert}>
                <span>{alert}</span>
              </div>)}
        </div>
        <div className={classes.basketItemsContainer}>
          {this.props.loading ? <Loader /> : null}
          {items.map((el, index) => (
            <BasketItem
              last={index === items.length - 1 && vouchered.length === 0}
              key={uuidv4()}
              book={el}
              onDelete={() => this.onDelete(el)}
            />))}
          <VoucherGroups groups={vouchered} />
        </div>
      </div>
    );
  }
}

BasketPaperInfo.propTypes = {
  classes: PropTypes.object,
  onSearch: PropTypes.func,
  search: PropTypes.object,
  basket: PropTypes.array,
  error: PropTypes.string,
  total: PropTypes.object,
  loading: PropTypes.bool,
  removeItem: PropTypes.func,
  setDeleteItem: PropTypes.func,
  deleteItem: PropTypes.object,
  onChangeInput: PropTypes.func,
  checkoutForTradeCustomer: PropTypes.func,
  basketNotifyError: PropTypes.string,
  disableGetPriceButton: PropTypes.bool,
  /** GetBookshopBasket's grouped view. Null for ordinary customers. */
  bookshopBasket: PropTypes.object,
};
BasketPaperInfo.defaultProps = {
  classes: {},
  bookshopBasket: null,
  onSearch: () => { },
  search: {},
  basket: [],
  error: '',
  total: {
    price: 0,
    items: 0,
  },
  loading: false,
  removeItem: () => { },
  setDeleteItem: () => { },
  deleteItem: null,
  onChangeInput: () => { },
  checkoutForTradeCustomer: () => { },
  basketNotifyError: null,
  disableGetPriceButton: true,
};

export default withStyles(styles)(BasketPaperInfo);
